import React from 'react'
import PropTypes from 'prop-types'
import WebFont from 'webfontloader'
import classes from './PostToolbar.module.scss'

WebFont.load({
  google: {
    families: ['Material Icons'],
  },
})

const DEFAULT_NODE = 'paragraph'

const LIST_ITEM = 'list-item'

const LIST_TYPES = ['bulleted-list', 'numbered-list']

const PostToolbar = ({ value, setValue }) => {
  const hasMark = (type) =>
    !!value.marks && value.marks.some((mark) => mark.type === type)
  const hasBlock = (type) =>
    !!value.blocks && value.blocks.some((node) => node.type === type)

  const onClickBlock = (e, type) => {
    e.preventDefault()
    const change = value.change()
    const isList = hasBlock(LIST_ITEM)
    const isActive = hasBlock(type)
    // Handle LIST
    if (LIST_TYPES.includes(type)) {
      if (type !== 'indent-decrease') {
        const isType = value.blocks.some(
          (block) =>
            !!value.document.getClosest(
              block.key,
              (parent) => parent.type === type
            )
        )
        if (isType && isList) {
          change
            .unwrapBlock(LIST_ITEM)
            .unwrapBlock('bulleted-list')
            .unwrapBlock('numbered-list')
            .setBlock(DEFAULT_NODE)
        } else if (isList) {
          change
            .unwrapBlock(
              type === 'bulleted-list' ? 'numbered-list' : 'bulleted-list'
            )
            .wrapBlock(type)
        } else {
          change.setBlock(LIST_ITEM).wrapBlock(type)
        }
      } else {
        if (isList) {
          change
            .unwrapBlock('list-item')
            .setBlock(isActive ? DEFAULT_NODE : type)
        }
        change.unwrapBlock('bulleted-list').unwrapBlock('numbered-list')
      }
    } else if (isList) {
      change
        .setBlock(isActive ? DEFAULT_NODE : type)
        .unwrapBlock('bulleted-list')
        .unwrapBlock('numbered-list')
    } else {
      change.setBlock(isActive ? DEFAULT_NODE : type)
    }
    setValue(change)
  }

  const onClickMark = (e, type) => {
    e.preventDefault()
    const change = value.change().toggleMark(type)
    setValue(change)
  }

  const renderMarkButton = (type, icon) => {
    const isActive = hasMark(type)
    const onMouseDown = (e) => onClickMark(e, type)

    return (
      <span
        role="button"
        tabIndex={-1}
        className={classes.toolbarButtons}
        onMouseDown={onMouseDown}
        data-active={isActive}
      >
        <span className={`material-icons ${classes.materialIcons}`}>
          {icon}
        </span>
      </span>
    )
  }

  const renderBlockButton = (type, icon) => {
    const isActive = hasBlock(type)
    const onMouseDown = (e) => onClickBlock(e, type)

    return (
      <span
        role="button"
        tabIndex={-1}
        className={classes.toolbarButtons}
        onMouseDown={onMouseDown}
        data-active={isActive}
      >
        <span className={`material-icons ${classes.materialIcons}`}>
          {icon}
        </span>
      </span>
    )
  }
  const isListActive = hasBlock(LIST_ITEM)
  return (
    <div className={classes.toolbar}>
      {renderMarkButton('bold', 'format_bold')}
      {renderMarkButton('italic', 'format_italic')}
      {renderMarkButton('underline', 'format_underlined')}
      {renderMarkButton('code', 'code')}
      {renderBlockButton('heading-one', 'looks_one')}
      {renderBlockButton('heading-two', 'looks_two')}
      {renderBlockButton('block-quote', 'format_quote')}
      {renderBlockButton('numbered-list', 'format_list_numbered')}
      {renderBlockButton('bulleted-list', 'format_list_bulleted')}
      {isListActive &&
        renderBlockButton('indent-decrease', 'format_indent_decrease')}
    </div>
  )
}

PostToolbar.propTypes = {
  value: PropTypes.object,
  setValue: PropTypes.func,
}
PostToolbar.defaultProps = {
  value: {},
  setValue: null,
}

export default PostToolbar
